import {
	Component,
	DestroyRef,
	input,
	InputSignal,
	OnInit,
	output,
	OutputEmitterRef,
	signal,
	WritableSignal
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatLabel } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

// models
import { SearchItem } from '../../models/chat';
import { IPlanogramLink } from '../../../planogram/models/planogramListItem';
import { LinkDtypeElement } from '../dtypes/link-dtype/link-dtype.component';

// services
import { ChatService } from '../../services/chat.service';
import { SessionService } from '../../services/session.service';
import { SnackBarService } from '../../services/snack-bar.service';

// components
import { PhChatComponent } from '../ph-chat/ph-chat.component';
import { PhChatSearchPanelComponent } from '../ph-chat-search-panel/ph-chat-search-panel.component';
import { PhIconComponent } from '../ph-icon/ph-icon.component';
import { PhIconWrapperComponent } from '../ph-icon-wrapper/ph-icon-wrapper.component';
import { GetLinkPipe } from '../../pipes/get-link.pipe';

@Component({
	selector: 'app-planogram-chat',
	templateUrl: './planogram-chat.component.html',
	styleUrls: ['./planogram-chat.component.scss'],
	imports: [
		PhIconComponent,
		PhIconWrapperComponent,
		PhChatComponent,
		MatTooltipModule,
		TranslateModule,
		MatLabel,
		MatMenuModule,
		RouterModule,
		GetLinkPipe,
		PhChatSearchPanelComponent
	]
})
export class PlanogramChatComponent implements OnInit {

	closeIcon: InputSignal<string> = input<string>();
	planogramLink: WritableSignal<LinkDtypeElement<IPlanogramLink>> = signal<LinkDtypeElement<IPlanogramLink>>(null);
	planogramName: InputSignal<string> = input<string>();

	close: OutputEmitterRef<void> = output<void>();
	closeAll: OutputEmitterRef<void> = output<void>();

	searchQuery: WritableSignal<string> = signal<string>('');
	searchPanelOpen: WritableSignal<boolean> = signal<boolean>(false);

	constructor(
		private destroyRef: DestroyRef,
		public chatService: ChatService,
		private sessionService: SessionService,
		private snackBarService: SnackBarService
	) {
	}

	ngOnInit(): void {
		if (this.sessionService.hasAccess('ph-planogram-view')) {
			this.loadPlanogramLink();
		}
	}

	private loadPlanogramLink(): void {
		this.chatService
			.getPlanogramLink(this.chatService.id)
			.pipe(takeUntilDestroyed(this.destroyRef))
			.subscribe({
				next: (link: LinkDtypeElement<IPlanogramLink>): void => this.planogramLink.set(link),
				error: (): void => {
					this.snackBarService.setSnackBarNotification({
						messageText: 'CHAT.PLANOGRAM_WAS_DELETED'
					});
				}
			});
	}

	onClose(): void {
		this.close.emit();
	}

	onSearch(query: string): void {
		this.searchQuery.set(query);
	}

	toggleSearchPanel(): void {
		this.searchPanelOpen.update((v: boolean): boolean => !v);
	}

	closeSearchPanel(): void {
		this.searchPanelOpen.set(false);
	}

	onSearchNavigate(item: SearchItem): void {
		this.chatService.scrollToMessage$.next(item.id);
	}
}
